import Request from './common/Request';

class LogApi {
    static async getLogs(filter) {
        return Request.post(filter, '/api/common/get-logs');
    }
}

export default LogApi;